import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-[10px] px-6 py-12 text-center',
        className,
      )}
    >
      {icon && (
        // Caixa de icone 44x44 rounded-[14px]
        <div className="mb-1.5 inline-flex h-11 w-11 items-center justify-center rounded-[14px] bg-surface-2 text-muted-foreground">
          {icon}
        </div>
      )}
      <p className="text-[15px] font-semibold text-foreground">{title}</p>
      {description && (
        <p className="max-w-[240px] text-[13px] leading-[1.45] text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-2.5">{action}</div>}
    </div>
  );
}
